import type { RootState } from "@lib/store";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: any = {
  filter: [
    {
      type: "propertyType",
      label: "Property Type",
      options: [],
      multiSelect: true,
    },
    {
      type: "community",
      label: "Community",
      options: [],
      multiSelect: true,
    },
    {
      type: "location",
      label: "Location",
      search: true,
      multiSelect: true,
    },
    {
      type: "keyword",
      label: "Keyword",
      search: true,
      multiSelect: true,
    },
    {
      type: "priceRange",
      label: "Price Range",
      min: 0,
      max: 0,
      step: 0,
    },
    {
      type: "areaRange",
      label: "Area Range (sqft)",
      min: 0,
      max: 0,
      step: 0,
    },
    {
      type: "numberOfBedrooms",
      label: "Beds",
      options: [],
    },
    {
      type: "numberOfBathroom",
      label: "Number of Bathroom",
      options: [],
    },
    {
      type: "amenities",
      label: "Amenities",
      multiSelect: true,
      search: true,
      options: [],
    },
    {
      type: "numberOfGarages",
      label: "Number of Garages",
      options: [],
    },
    {
      type: "numberOfParking",
      label: "Number of Parkings",
      options: [],
    },
  ],
};

export const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    setFilter: (state, action: PayloadAction<any>) => {
      state.filter = action.payload;
    },
  },
});

export const { setFilter } = filterSlice.actions;

export const getFilterState = (state: RootState) => state.filter;

export default filterSlice.reducer;
